__webpack_require__.p = "/healthscope.ai/";